import { render, staticRenderFns } from "./files-updown-ios.vue?vue&type=template&id=5fdfb7c3&scoped=true&"
import script from "./files-updown-ios.vue?vue&type=script&lang=ts&"
export * from "./files-updown-ios.vue?vue&type=script&lang=ts&"
import style0 from "./files-updown-ios.vue?vue&type=style&index=0&id=5fdfb7c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fdfb7c3",
  null
  
)

export default component.exports